// @vue/component

export default {
  name: 'ShProgressBar',

  props: {
    maxTime: {
      type: Number,
      default: 0,
    },
    leftTime: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '#fff',
    },
    height: {
      type: String,
      default: '98%',
    },
    maxWidth: {
      type: String,
      default: '1395px',
    },
  },
  data() {
    return {
      widthOfProgress: 0,
      onePercent: 0,
    };
  },
  created() {
    if (this.leftTime >= this.maxTime) {
      this.widthOfProgress = 100;
      this.stopCounting();
    } else {
      this.widthOfProgress = 0;
      this.setPercent(this.leftTime, this.maxTime);
      this.startCounting();
    }
  },
  computed: {
    dynamicWidth() {
      return `${this.widthOfProgress}%`;
    },
  },
  beforeDestroy() {
    this.stopCounting();
  },
  methods: {
    startCounting() {
      if (this.widthOfProgress < 100 && this.widthOfProgress >= 0) {
        this.widthOfProgress += this.onePercent;
        this.timer = setTimeout(this.startCounting, 1000);
      } else {
        this.$emit('finish');
        this.stopCounting();
      }
    },
    getLighterColor() {
      const color = require('color');
      return color(this.color).lighten(0.4);
    },
    getDarkenColor() {
      const color = require('color');
      return color(this.color).darken(0.07);
    },
    setPercent(percentValue, wholeValue) {
      this.widthOfProgress = (100 * percentValue) / wholeValue;
      this.onePercent = (100 * 1) / wholeValue;
    },
    stopCounting() {
      clearTimeout(this.timer);
      this.timer = 0;
    },
  },
};
